import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../Component/LayoutComponent/Sidebar2';
import TravelDashboardHeader from '../../Component/LayoutComponent/Header';

const MainLayout = () => {
  const [activePage, setActivePage] = useState('dashboard');
  
  const handlePageChange = (pageId) => {
    setActivePage(pageId);
    // You could also implement navigation here with react-router
    // navigate(`/${pageId}`);
  };
  
  return (
    <div className="flex h-screen overflow-hidden bg-slate-50">
      {/* Sidebar - higher z-index for mobile overlay */}
      <div className="h-screen flex-shrink-0 z-30 relative">
        <Sidebar activePage={activePage} onPageChange={handlePageChange} />
      </div>
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        {/* Header - lower z-index, positioned relative */}
        <div className="flex-shrink-0 z-20 relative">
          <TravelDashboardHeader />
        </div>
        
        {/* Page Content - scrollable content area */}
        <div className="flex-1 overflow-hidden relative z-10">
          <main className="p-4 md:p-8 h-full overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;